import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

export const FooterSection = forwardRef((props, ref) => {
  const { as = 'section', children, ...rest } = props
  const Comp = as
  return (
    <Comp className="dev_dash__footer_section" {...rest} ref={ref}>
      <div className="dev_dash__footer_section--container">{children}</div>
    </Comp>
  )
})

FooterSection.displayName = 'FooterSection'

FooterSection.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
}
